// extracted by mini-css-extract-plugin
export default {"listLabel":"preferences-dialog_listLabel__zNxOU","listLabelText":"preferences-dialog_listLabelText__wWTsY","selectAll":"preferences-dialog_selectAll__sWI2X"};